<template>
  <div>
    <ModuleHeader>Reporte Reservas</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="6" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker @selected="selectDate" :value="input_date.format('MM/DD/YYYY')"></Datepicker>
              </v-col>
              <v-col md="6" cols="12" class="input">
                <label>Fecha final</label>
                <Datepicker @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete label="Actividad" v-model="rvaDepto" :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete :disabled="afiliado" item-value="id" item-text="text" label="Agencia"
                  v-model="selectedHotel" :items="comp_hotel"></v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete item-value="id" item-text="nom" label="Concierge" v-model="selectedConcierge"
                  :items="concierges"></v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-select label="Estatus" v-model="statusFilter" :items="compStatus" item-text="Nombre" item-value="id">
                </v-select>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete :disabled="afiliado" label="Clientes" v-model="clienteFilter" :items="comp_clients">
                </v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete label="Tarifario" v-model="TarifarioFilter" :items="comp_tarifario" item-value="Id"
                  item-text="Nombre">
                </v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete class="mb-n2" label="Nombre de tarifa" :items="subcategorias" v-model="cateTarifa"
                  item-value="id" item-text="text">
                </v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete class="mb-n2" label="Modalidad" :items="compTipoJuego" v-model="tipoJuegoFilter"
                  item-value="id" item-text="Nombre">
                </v-autocomplete>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete class="mb-n2" label="Salida" :items="compSalidas" v-model="salidaFilter" item-value="id"
                  item-text="Nombre">
                </v-autocomplete>
              </v-col>

              <v-col md="12" cols="12">
                <v-btn @click="getReservas()" color="green" dark>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-alert outlined color="primary">
          <div class="text-h6">
            Estadistica
          </div>
          <div class="text-caption-1">
            <v-row>
              <v-col md="12" cols="12">
                Reservas : {{ reservas_comp.length }} || Reservados : {{ totalPlayers }} || Pagados: {{ totalPagados }}
                || No Show {{ totalNoShow }} || Pendientes: {{ totalPlayers - (totalPagados + totalNoShow) }} ||
                Cancelados:
                {{ totalCancelados }} || TotalMXN: {{ $pgsHelper.formatNumber(totalPrecio.precioMX) }} || TotalUSD: {{
                  $pgsHelper.formatNumber(totalPrecio.precioUSD) }}
              </v-col>
            </v-row>
          </div>
        </v-alert>
      </v-col>

      <v-col md="12" cols="12">
        <v-row>
          <v-col md="4"> Resultados: </v-col>

          <v-col md="8" class="text-right">
            <v-btn @click="prePrintPdf = true" color="red" dark><v-icon>mdi-file-pdf</v-icon>

              Generar PDF
            </v-btn>
            <v-btn color="green" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
              Exportar a Excel
              <!-- <download-excel
                type="xls"
                name="Reporte reservas"
                :data="reservas_comp"
                :fields="json_fields"
              >
              </download-excel> -->
            </v-btn>
          </v-col>
        </v-row>
        <v-simple-table class="dense-table">
          <thead>
            <tr>
              <th>Folio</th>
              <th>Tipo juego</th>
              <th>Salida</th>
              <th>A traves de</th>
              <th>Cliente</th>
              <th>Jugadores</th>
              <th>Creacion</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Estatus</th>
              <th>Folio Venta</th>
              <th>Notas</th>
              <th>Agencia</th>
              <th>Concierge</th>
              <th>Tarifario</th>
              <th>SubCategoria</th>
              <th>Total</th>
              <th>Moneda</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="reservations.length == 0">
              <td colspan="7">No se encontraron datos</td>
            </tr>
            <template v-for="(res, index) in reservas_comp">
              <tr :key="index">
                <td>{{ res.Folio }}</td>
                <td>{{ res.TipoJuegoNombre }}</td>
                <td>{{ res.BahiaNombre }}</td>
                <td>{{ res.creadoEn }}</td>
                <td>{{ res.playerNombre }}</td>
                <td>{{ res.totalAccount }}</td>
                <td>{{ res.Creacion }} <br /> {{ res.Creador.Name }}</td>
                <td>{{ res.date_format }}</td>
                <td>{{ res.time_format }}</td>
                <td>
                  <b v-if="res.Estatus == 'Confirmed'" class="primary--text">Confimado</b>
                  <b v-else-if="res.Estatus == 'Cancelled'" class="red--text">Cancelado</b>
                  <b v-else-if="res.Estatus == 'No Show'" class="greey--text">{{
                    res.Estatus
                  }}</b>
                  <b v-else-if="res.Estatus == 'Pagado'" class="green--text">Pagado</b>
                  <b v-else>{{ res.Estatus }} {{ res.totalPagado }} de
                    {{ res.totalAccount }}
                  </b>
                </td>
                <td>{{ res.FolioVenta }}</td>
                <td>{{ res.Notas }}</td>
                <td>{{ res.NombreHotel }}</td>
                <td>{{ res.Concierge }}</td>
                <td>{{ res.TarifarioName }}</td>
                <td>{{ res.SubCategoriaNombre }}</td>
                <td>${{ res.Precio }}</td>
                <td>{{ res.Moneda }}</td>
                <td>
                  <v-btn @click="selectRes(res)" color="success">Bitacora</v-btn>
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog v-model="prePrintPdf" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Generar PDF
        </v-card-title>
        <v-card-text>Seleccione una opción </v-card-text>
        <v-card-text>
          <v-row>
            <v-col @click="generatePdfConcierges()" md="4">
              <v-btn color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Detalle por concierge
              </v-btn>
            </v-col>
            <v-col md="4">
              <v-btn @click="generatePdfDetailed()" color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Detalle por Agencia
              </v-btn>
            </v-col>
            <v-col md="4">
              <v-btn @click="generatePdfTotalTarifario()" color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Totalizado por Tarifario
              </v-btn>
            </v-col>
            <v-col @click="generatePdf()" md="4">
              <v-btn @click="prePrintPdf = true" color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Todas las Reservas
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="prePrintPdf = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bitacoraToogle" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Bitacora de cambios de la reserva {{ selectedRes.Folio }}
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(reg, index) in selectedRes.Log" :key="index">
              <v-list-item-content>
                <v-card class="mx-4">
                  <v-card-text>
                    <b>Informacion de cambio</b><br />
                    <b>Realizado por:</b>{{ reg.u }}<br />
                    <b>Fecha:</b>{{ formatDate(reg.f) }}<br />
                    <ul>
                      <template v-for="(change, indexChange) in reg.c">
                        <li :key="indexChange">
                          <b>{{ change.m }}</b>
                        </li>

                        <div class="mb-8" :key="indexChange + ' ' + index">
                          <div class="my-4">Antes : {{ change.w.p }}</div>
                          <div class="my-4">Despues:{{ change.w.n }}</div>
                        </div>
                      </template>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "../../assets/css/custom.css";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Cliente from "../../clases/Cliente.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import RepoReservas from "../../clases/PdfMakers/RepoReservas";
import RepoReservasAfiliado from "../../clases/PdfMakers/RepoReservasAfiliado";
import RepoReservasConcierge from "../../clases/PdfMakers/ReporteReservasConcierge.js";
import RepoReservasTarifario from "../../clases/PdfMakers/ReporteReservasTarifario.js"
import TarifasClass from "../../clases/Tarifa.js";
import Currency from "../../clases/Currencies.js";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { mapGetters } from "vuex";
export default {
  name: "repo_reservas",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      tiposJuego: [],
      cateTarifa: "ALL",
      subcategorias: [],
      rvaDepto: "ALL",
      selectedRes: {},
      TarifarioFilter: "ALL",
      tipoJuegoFilter: "ALL",
      salidaFilter: "ALL",
      afiliado: false,
      concierge: false,
      selectedConcierge: "All",
      prePrintPdf: false,
      clienteFilter: "All",
      statusFilter: "All",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      showModal: false,
      bitacoraToogle: false,
      MainDepartamento: "",
      formKey: 0,
      selectedHotel: "",
      hoteles: [],
      concierges: [],
      Horario: "",
      Horarios: [],
      reservations: [],
      status: [],
      tarifarios: [],
      tarifariosGlobal: [],
    };
  },
  methods: {
    exportExcel() {
      const options = {
        json_fields: this.json_fields
      }
      GenericExcelExporter.generateExcelBuffer(this.reservas_comp, options)
        .then(buffer => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = "Reporte de reservas.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(err => console.error("Error exportando Excel:", err));
    },
    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/SubCategorias"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());
      this.subcategorias.push({
        text: "TODOS",
        id: "ALL",
        value: "ALL",
      })
      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    selectRes(data) {
      this.bitacoraToogle = true;
      this.selectedRes = data;
    },
    async getConcierges() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Concierge"
      );
      if (!data.exists()) {
        return false;
      }
      let concierges = Object.entries(data.val());
      let conciergesData = [{ id: "All", nom: "Todos" }];
      concierges.forEach(function (element) {
        conciergesData.push({
          id: element[0],
          ...element[1],
        });
      });
      this.concierges = conciergesData;
    },
    async getComboTarifarios() {

      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      let tarifariosGlobal = await TarifasClass.getAllTarifarios();


      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
      this.tarifariosGlobal = tarifariosGlobal
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("DD-MM-YYYY HH:mm");
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas",
        data: this.reservas_comp,
      };
      let docData = RepoReservas.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfTotalTarifario() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas Totalizado Tarifarios",
        data: this.reservas_comp,
      };
      let docData = RepoReservasTarifario.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfDetailed() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas Agencias",
        data: this.reservas_comp,
      };
      let docData = RepoReservasAfiliado.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfConcierges() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas Concierge",
        data: this.reservas_comp,
      };
      let docData = RepoReservasConcierge.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Mayoristas/Coleccion",
        null,
        (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
      );
    },
    deletHotel(idHotel) {
      this.$swal({
        title: "¿Deseas eliminar esta agencia?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { hId: idHotel };
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Hoteles-eliminarHotel", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Agencia eliminada",
              "La agencia se eliminó correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal(
              "Error al eliminar los datos",
              "Los datos no se pudieron eliminar",
              "error"
            );
          }
        }
      });
    },
    successData(data) {
      let duration =
        data.duracion.horas.toString().padStart(2, "0") +
        ":" +
        data.duracion.minutos.toString().padStart(2, "0") +
        ":00";
      let dataHotel = {
        hotelCode: data.codigo,
        hotelName: data.nombre,
        duracionViaje: duration,
      };
      this.saveHotel(dataHotel);
    },
    saveHotel(data) {
      this.$swal({
        title: "Deseas guardar la agencia?",
        text: "La agencia se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Hoteles-crearHotel", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Agencia Guardada",
              "La agencia se almacenó correctamente",
              "success"
            );

            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              "Los datos no fueron guardados",
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getStatus() {
      const database = this.$store.getters.getFirebaseApp.database;
      let data = await database.queryBuilder("RVA/Estatus", [
        database.orderByValue(),
        database.startAt(true),
        database.endAt(true),
      ]);
      let status = data.val();

      this.status = status;
    },
    async getReservas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filters = [
        firestore.where("RF.FI", ">=", startDate),
        firestore.where("RF.FI", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectedHotel !== "") {
        if (this.selectedHotel !== "Admin" && this.selectedHotel !== "Web") {
          let hotel = this.$pgsHelper.getById(
            this.hoteles,
            "Codigo",
            this.selectedHotel
          );
          if (hotel) {
            filters.push(firestore.where("Mayorista.Id", "==", hotel.id));
          }

        } else {
          filters.push(firestore.where("Creador", "==", this.selectedHotel));
        }
      }

      if (this.rvaDepto != "ALL") {
        filters.push(firestore.where("Departamento", "==", this.rvaDepto));
      }

      if (this.clienteFilter != "All") {
        filters.push(firestore.where("_IDX", "array-contains", "C#.I=" + this.clienteFilter));
      }

      const data = await firestore.queryBuilder("RVA_Reservas", filters);

      this.reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      // console.log(this.reservations);
      this.showEstad = true;
      this.loadingData = false;

      this.reservations.forEach((element) => {
        if (element.Tarifas) {
          let tarifas = Object.entries(element.Tarifas);
          element.TarifasList = tarifas;
        }
      });
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Modalidades"
        );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },
  },
  computed: {
    ...mapGetters(["getSalidas"]),
    compTipoJuego() {
      let arrayTipos = [{ id: "ALL", Nombre: "Todos" }];
      this.tiposJuego.forEach((element) => {
        arrayTipos.push({
          id: element.id,
          Nombre: element.nombre,
        });
      });
      return arrayTipos;
    },
    compStatus() {
      let arrayStatus = [
        { id: "All", Nombre: "Todos" },
        { id: "Pagado", Nombre: "Pagado" },
        { id: "Parcial", Nombre: "Pagado Parcial" },
        { id: "No Show", Nombre: "No Show" },
        { id: "Confirmed", Nombre: "Reservados (Pendientes de check in)" }
      ];
      /*let status = [];
      if (this.status) {
        status = Object.keys(this.status);
      }
      status.forEach((element, index) => {
        let selected = false;
        let totalRes = 0;
        arrayStatus.push({
          id: element,
          Nombre: element,
          cantidad: totalRes,
          selected: selected,
        });
      });*/

      return arrayStatus;
    },
    json_fields() {
      let ObjTitle = {
        Folio: "Folio",
        TipoJuego: "TipoJuegoNombre",
        Salida: "Salida",
        Creador: "creadoEn",
        Cliente: "playerNombre",
        Jugadores: "totalAccount",
        Creacion: "CreacionNombre",
        Fecha: "date_format",
        Hora: "time_format",
        Estatus: "Estatus",
        FolioVenta: "FolioVenta",
        Notas: "Notas",
        Agencia: "NombreHotel",
        Concierge: "Concierge",
        Tarifario: "TarifarioName",
        Subcategoria: "SubCategoriaNombre",
        Total: "Precio",
        Moneda: "Moneda",

      };
      return ObjTitle;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    compSalidas() {
      let arraySalidas = [{ id: "ALL", Nombre: "Todos" }];
      this.getSalidas.forEach((element) => {
        arraySalidas.push({
          id: element.id,
          Nombre: element.nombre,
        });
      });
      return arraySalidas;
    },
    reservas_comp() {
      let res = [];
      this.reservations.forEach((ele) => {
        if (ele.Mayorista) {
          let index = this.$_.findIndex(this.hoteles, ["id", ele.Mayorista.Id]);
          ele.NombreHotel = this.hoteles[index]?.Nombre;
        } else {
          ele.NombreHotel = ele.Departamento;
        }
        if (ele.Cuentas) {
          //let totalAccount = 0;
          let totalPagado = 0;
          let totalCancelado = 0;
          let totalNoShow = 0
          let cuentas = Object.entries(ele.Cuentas);
          cuentas.forEach((cuenta) => {
            let totalAccount = 0;
            if (cuenta[0] !== "Extra") {
              let format_date = moment(ele.RF.FI, "YYYY-MM-DD_HH:mm:ss");
              let item = {
                format_date: moment(ele.RF.FI, "YYYY-MM-DD_HH:mm:ss"),
                date_format: format_date.format("DD-MM-YYYY"),
                time_format: format_date.format("HH:mm"),
                creadoEn: ele.Creador.Type,
                mxn: this.$pgsHelper.formatNumber(ele.Totales.MXN),
                usd: this.$pgsHelper.formatNumber(ele.Totales.USD),
                NombreHotel: ele.NombreHotel,
                Concierge: ele.Concierge
                  ? this.$pgsHelper.getById(
                    this.concierges,
                    "id",
                    ele.Concierge.Id
                  ).nom
                  : "",
                ConciergeData: ele.Concierge
                  ? this.$pgsHelper.getById(
                    this.concierges,
                    "id",
                    ele.Concierge.Id
                  )
                  : null,
              };
              totalAccount++;
              if (cuenta[1].Estatus === "P") {
                totalPagado = 1;
              }
              if (cuenta[1].Estatus === "C") {
                totalCancelado = 1;
              }
              if (cuenta[1].Estatus === "N") {
                totalNoShow = 1;
              }
              if (item.ConciergeData) {
                let valorComision =
                  item.ConciergeData.cms.tp == "$"
                    ? item.ConciergeData.cms.vl.C +
                    " " +
                    item.ConciergeData.cms.vl.M
                    : item.ConciergeData.cms.vl;
                item.TipoComision =
                  item.ConciergeData.cms.tp + " " + valorComision;
                item.Comision = { C: 0, M: "MXN" };
                if (cuenta[1].Estatus === "P") {
                  if (item.ConciergeData.cms.tp == "$") {
                    item.Comision = item.ConciergeData.cms.vl;
                  } else {
                    let amount =
                      Number(
                        cuenta[1].Catalogo[0].Pco * item.ConciergeData.cms.vl
                      ) / 100;
                    item.Comision = { C: amount, M: cuenta[1].Catalogo[0].Mnd };
                  }
                }
              } else {
                item.TipoComision = "NA";
                item.Comision = { C: 0, M: "MXN" };
              }
              item.Folio = ele.Folio;
              item.PlayerId = cuenta[1].IdCliente;
              item.Creador = ele.Creador
              item.Creacion = this.formatDate(ele.FechaCreacion);
              item.CreacionNombre = this.formatDate(ele.FechaCreacion) + " " + (ele.Creador.Name ? ele.Creador.Name : "")
              item.playerNombre = cuenta[1].Nombre;
              item.totalAccount = totalAccount;
              item.totalPagado = totalPagado;
              item.totalCancelado = totalCancelado;
              item.Notas = ele.Notas;
              item.TipoJuego = cuenta[1]?.Catalogo[0]?.ExtraParams?.TarifaData?.Mod;
              item.TipoJuegoNombre = this.$_.find(this.tiposJuego, ["id", item.TipoJuego])?.nombre;
              item.Bahia = ele.Bahia
              item.BahiaNombre = this.$_.find(this.getSalidas, ["id", item.Bahia])?.nombre;
              item.Salida = item.BahiaNombre;
              item.Precio = cuenta[1].Catalogo[0].Pco;
              item.Moneda = cuenta[1].Catalogo[0].Mnd;
              item.ConciergeId = ele.Concierge ? ele.Concierge.Id : null;
              item.FolioVenta = cuenta[1].Catalogo[0].FVenta;
              item.Log = ele.__ChangeLog;
              let Tarifario =
                cuenta[1]?.Catalogo[0]?.ExtraParams?.TarifaData?.Tar || null;

              item.Tarifario = Tarifario;

              item.SubCategoriaNombre = cuenta[1]?.Catalogo[0]?.ExtraParams?.TarifaData?.SubN
              item.SubCategoria = cuenta[1]?.Catalogo[0]?.ExtraParams?.TarifaData?.Sub

              item.TarifarioName = this.$pgsHelper.getById(
                this.tarifariosGlobal,
                "Id",
                Tarifario
              ).Nombre;
              if (cuenta[1].Catalogo[0].Tip == "Serie") {
                item.SubCategoriaNombre = cuenta[1].Catalogo[0].Nombre
                item.TarifarioName = "Rondas Prepagadas"
              }
              if (cuenta[1].Estatus === "P") {
                item.Estatus = "Pagado";
              } else if (cuenta[1].Estatus === "C") {
                item.Estatus = "Cancelled";
              } else if (cuenta[1].Estatus === "N") {
                item.Estatus = "No Show";
              } else {
                item.Estatus = ele.Estatus;
              }

              const matchesCliente = this.clienteFilter === "All" || item.PlayerId === this.clienteFilter;
              const matchesStatus = this.statusFilter === "All" || item.Estatus === this.statusFilter;
              const matchesTipo = this.tipoJuegoFilter === "ALL" || item.TipoJuego === this.tipoJuegoFilter;
              const matchesSalida = this.salidaFilter === "ALL" || item.Bahia === this.salidaFilter;

              if (matchesCliente && matchesStatus && matchesTipo && matchesSalida && matchesSalida) {
                res.push(item);
              }
            }
          });

          /*ele.totalAccount = totalAccount;
          ele.totalPagado = totalPagado;
          ele.totalCancelado = totalCancelado;
          if (ele.totalPagado > 0) {
            if (totalPagado === totalAccount) {
              ele.Estatus = "Pagado";
            } else {
              ele.Estatus = "Parcial";
            }
          }*/
        }
        /* if (this.statusFilter == "All") {
          res.push(ele);
        } else {
          if (this.statusFilter == ele.Estatus) {
            res.push(ele);
          }
        }*/
      });
      let filteredConcierges = res;
      if (this.selectedConcierge != "All") {
        filteredConcierges = this.$_.filter(res, (o) => {
          return o.ConciergeId == this.selectedConcierge;
        });
      }
      let filteredTarifario = filteredConcierges
      if (this.TarifarioFilter != "ALL") {
        // console.log("entre");
        let tarifasMatched = this.$_.filter(filteredConcierges, (o) => {
          return o.Tarifario == this.TarifarioFilter;
        });
        filteredTarifario = tarifasMatched;
      }
      let filterSubcate = filteredTarifario
      if (this.cateTarifa != "ALL") {
        let tarifasMatched = this.$_.filter(filteredTarifario, (o) => {
          return o.SubCategoria == this.cateTarifa;
        });
        filterSubcate = tarifasMatched;
      }
      return filterSubcate;
    },
    total() {
      let total = 0;
      this.reservations.forEach((ele) => {
        total = total + ele.Totales.USD;
      });
      var formatter = new Intl.NumberFormat("en-US");

      return formatter.format(total);
    },
    golfClub() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "GolfClub"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    extraRider() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "ExtraRidder"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    totalNoShow() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus == "No Show") {
          golf = golf + ele.totalAccount;
        }
      });
      return golf;
    },
    totalPlayers() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus !== "Cancelled") {
          golf = golf + ele.totalAccount;
        }
      });
      return golf;
    },
    totalPagados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus === "Pagado") {
          golf = golf + ele.totalPagado;
        }
      });
      return golf;
    },
    totalCancelados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus == "Cancelled") {
          golf = golf + ele.totalAccount;
        }
      });
      return golf;
    },
    comp_hotel() {
      let hotel = [
        { id: "", text: "Todos" },
        { id: "Admin", text: "Administrador" },
        { id: "Web", text: "Sitio Web" },
      ];
      this.hoteles.forEach((ele) => {
        hotel.push({ id: ele.Codigo, text: ele.Nombre });
      });
      return hotel;
    },
    comp_tarifario() {
      let tarifarios_comp = [{ Id: "ALL", Nombre: "Todos" }];
      this.tarifarios.forEach((tar) => {
        tarifarios_comp.push(tar);
      });
      return tarifarios_comp;
    },
    comp_clients() {
      let clientes = [{ value: "All", text: "Todos" }];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    departamentos() {
      let deptos = [{ text: "Todos", value: "ALL" }];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        (dep.text = dep.Nombre), (dep.value = dep.id);
        deptos.push(dep);
      });
      return deptos;
    },
    totalPrecio() {
      let precioMX = null;
      let precioUSD = null;

      this.reservas_comp.forEach((item) => {
        if (item.Estatus !== "Cancelled") {
          precioMX += Currency.getExchangeRateByCurrency(
            item.Precio,
            item.Moneda,
            "MXN"
          );
          precioUSD += Currency.getExchangeRateByCurrency(
            item.Precio,
            item.Moneda,
            "USD"
          );
        }
      });
      return { precioMX, precioUSD };
    },

  },
  watch: {},
  mounted() {
    this.getComboTarifarios();
    if (this.$route.params.user.tokenResult.claims.Code) {
      this.afiliado = true;
      this.selectedHotel = this.$route.params.user.tokenResult.claims.Code;
    }
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getConcierges();
    this.getHorarios();
    this.getHoteles();
    this.getStatus();
    this.getTiposJuego();
    //this.getComboTarifarios();
    this.getSubcategoria()
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
